import { render, staticRenderFns } from "./SymptomInvestigationTable.vue?vue&type=template&id=0a0ce7f0&scoped=true&"
import script from "./SymptomInvestigationTable.vue?vue&type=script&lang=js&"
export * from "./SymptomInvestigationTable.vue?vue&type=script&lang=js&"
import style0 from "./SymptomInvestigationTable.vue?vue&type=style&index=0&id=0a0ce7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ce7f0",
  null
  
)

export default component.exports